import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';

import {
  getAge,
  formatDateToDayShortWithYear,
  convertClientDateToServerDate,
} from '../../../../../../utils/dateUtils';
import { pluralizeYears } from '../../../../../../utils/pluralizeUtils';

import styles from './toutists.module.css';

const Tourists = ({ className = '', data, onClick, isMobile }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(styles.container, className)}>
      {!isMobile && (
        <div className={styles.text}>{t('checkout.sidebar.tourists')}</div>
      )}
      <div className={styles.list}>
        {data.map(
          (
            {
              name,
              surname,
              birthday,
              passport_number,
              passport_expires_on,
              hideDocInputs,
            },
            idx,
          ) => {
            const parseBirthday = convertClientDateToServerDate(birthday);
            const birthdayFormatted =
              formatDateToDayShortWithYear(parseBirthday);
            const age = getAge(parseBirthday);

            return (
              <button
                type="button"
                className={styles.item}
                onClick={onClick}
                // eslint-disable-next-line react/no-array-index-key
                key={passport_number + idx} // in case of same passport number (i.e testing)
              >
                <div className={cn(styles.text, styles.nameText)}>
                  {`${surname} ${name}`}
                </div>

                <div className={styles.text}>
                  {`${age} ${pluralizeYears(age)} · ${birthdayFormatted}`}
                </div>

                <div className={styles.text}>
                  {hideDocInputs ? (
                    <span>{t('checkout.sidebar.dataLater')}</span>
                  ) : (
                    <span>
                      <span>{passport_number}</span>
                      {passport_expires_on && (
                        <span> · {passport_expires_on}</span>
                      )}
                    </span>
                  )}
                </div>
              </button>
            );
          },
        )}
      </div>
    </div>
  );
};

Tourists.defaultProps = {
  isMobile: false,
};

Tourists.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      birthday: PropTypes.string.isRequired,
      gender: PropTypes.string.isRequired,
      hideDocInputs: PropTypes.bool.isRequired,
      passport_number: PropTypes.string,
    }),
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};
export default Tourists;
